import React, {
  useCallback,
} from 'react';
import ConsentFormIcon from 'core/icons/consentForm';
import {
  Button,
} from '@populateui/ui';
import {
  PatientForm,
} from 'pages/Dashboard/types/patient';
import {
  PatientCompact,
} from 'pages/Dashboard/pages/Encounters/types/patient';
import {
  visitNoteFormEventChannel,
} from 'pages/Dashboard/services/eventChannels';
import ToolTip from 'core/components/Tooltip';

type Props = {
  patient: PatientForm;
};

export default function ConsentFormButton({ patient }: Props) {
  const handleOpenFormWorkflow = useCallback(() => {
    visitNoteFormEventChannel.emit('onOpenStartFormWorkflow', {
      patient: patient as PatientCompact,
    });
  }, [patient]);

  return (
    <ToolTip title="Forms">
      <Button
        variant="outlined"
        className="!h-8"
        onClick={handleOpenFormWorkflow}
      >
        <ConsentFormIcon className="!w-4 !h-4 !text-inherit" />
      </Button>
    </ToolTip>
  );
}
